import { ComponentType } from "react";
import { Redirect, Route as ReactRoute, RouteProps } from "react-router-dom";
import { useAuth } from "../providers/Auth";

interface Props extends RouteProps {
  isPrivate?: boolean;
  isAdmin?: boolean;
  component: ComponentType;
}

const Route = ({
  isPrivate = false,
  isAdmin = false,
  component: Component,
  ...rest
}: Props) => {
  const { accessToken } = useAuth();
  console.log(accessToken);

  return (
    <ReactRoute
      {...rest}
      render={() =>
        isPrivate === !!accessToken ? (
          <Component />
        ) : (
          <Redirect to={accessToken ? "/dashboard" : "/"} />
        )
      }
    />
  );
};

export default Route;
